import api from "services/api";

export const axiosAuthHeader = () => {
    if(api.token){
        return {
            headers: {Authorization: `Bearer ${api.token}`}
        };
    } else {
        return {
            headers: {Authorization: `Bearer `}
        };
    }
}